import { createSlice } from "@reduxjs/toolkit";
import { sendSMSByToken } from "../thunks/smsThunks";

interface SMSState {
  loading: boolean;
  error: string | null;
  success: boolean;
  message: string | null;
}

const initialState: SMSState = {
  loading: false,
  error: null,
  success: false,
  message: null,
};

const smsSlice = createSlice({
  name: "sms",
  initialState,
  reducers: {
    resetSMSState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendSMSByToken.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.message = null;
      })
      .addCase(sendSMSByToken.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
      })
      .addCase(sendSMSByToken.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "שגיאה בשליחת SMS";
      });
  },
});

export const { resetSMSState } = smsSlice.actions;
export default smsSlice.reducer;
